import axios from "./request";
const getUserInfo = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  return user || {};
};
export const Log = behavior => {
  const { id: uid, nickname, name } = getUserInfo();
  const data = new FormData();
  data.append("uid", uid);
  data.append("nickname", nickname);
  data.append("username", name);
  data.append("behavior", nickname + behavior);
  axios.post("/log_add", data);
};

export const LogList = params => {
  const { page, name } = params;
  const data = new FormData();
  data.append("page", page);
  data.append("name", name);
  return axios.post("/log_list", data);
};



// WEBPACK FOOTER //
// ./src/request/log.js